<div class="pop-inputs">

  <div class="dialog-title"
       translate="TOOLBAR.PARAMETERS"></div>
  <div *ngIf="currentEstimate"
       class="body">

    <form #parametersForm="ngForm"
          autocomplete="off">
      <h2>
        <pop-chevron [(isExpanded)]="showSections.information">
          <span translate="MODAL.INFO"></span>
        </pop-chevron>
      </h2>
      <ng-container *ngIf="showSections.information">
        <div class="info-content">
          <div class="info-col">
            <div class="form-group">
              <label class="info-name"
                     for="codeRef"
                     translate="PROPERTY_MODAL.REF">
              </label>
              <input class="parameter-field"
                     id="codeRef"
                     required
                     disabled
                     [(ngModel)]="currentEstimate.codeRef"
                     [disabled]="!isStatusTypeNew || isGroupApproved"
                     name="codeRef"
                     type="text" />
            </div>

            <div class="form-group"
                 *ngIf="hasCRM">
              <!-- with crm -->
              <label class="info-name"
                     for="projectCode"
                     translate="PROPERTY_MODAL.ID"></label>
              <input class="parameter-field"
                     id="projectCode"
                     required
                     disabled
                     [(ngModel)]="currentEstimate.projectCode"
                     [disabled]="!isStatusTypeNew || isGroupApproved"
                     name="projectCode"
                     type="text" />
            </div>

            <div class="form-group"
                 *ngIf="!hasCRM">

              <!-- with no crm -->
              <label class="info-name"
                     translate="PROPERTY_MODAL.ID">
              </label>


              <pop-project-picker styleClass="rem-fix"
                                  class="parameter-dialog large parameter-field"
                                  [(selectedProjectCode)]="currentEstimate.projectCode"
                                  [readonly]="isEstimateReadonly">
              </pop-project-picker>

            </div>

            <div class="form-group">
              <label class="info-name"
                     for="projectName"
                     translate="PROPERTY_MODAL.PROJ_TITLE"></label>
              <input maxlength="31"
                     class="parameter-field"
                     id="projectName"
                     required
                     [(ngModel)]="currentEstimate.projectName"
                     name="projectName"
                     [disabled]="isEstimateReadonly || hasCRM"
                     type="text" />
            </div>

            <div class="form-group">
              <label class="info-name"
                     for="rate"
                     translate="HEADER.RATE"></label>
              <input placeholder="0.00"
                     #rate
                     class="parameter-field"
                     type="number"
                     [(ngModel)]="currentEstimateRate"
                     [disabled]="!isStatusTypeNew || isGroupApproved"
                     name="rate" />
            </div>

            <div *ngIf="settings?.activateInternalFees"
                 class="form-group">
              <label class="info-name"
                     for="internalResourceGroup"
                     translate="PROPERTY_MODAL.INTERNAL_RESOURCE_GROUP">
              </label>

              <pop-select [options]="internalResourceGroups"
                          class="parameter-field"
                          [disabled]="isEstimateReadonly"
                          keyField="id"
                          labelField="code"
                          [selectedOption]="currentEstimate.internalResourceGroupId || ''"
                          (selectedOptionChange)="currentEstimate.internalResourceGroupId = $event || null">
              </pop-select>

            </div>

            <div class="form-group">
              <label class="info-name"
                     translate="PROPERTY_MODAL.MAX_BUDGETED">
              </label>

              <pop-switch [disabled]="isEstimateReadonly || fixedMaxBudgeted"
                          [(isSwitched)]="currentEstimate.maxBudgeted"></pop-switch>
            </div>

            <div class="form-group"
                 *ngIf="!isEstimateTypeNew && !projectCreatedByPop">
              <label class="info-name"
                     translate="PROPERTY_MODAL.FORCE_GP_BUDGET_VALIDATION">
              </label>


              <pop-switch [disabled]="!isStatusTypeNew || isGroupApproved"
                          [(isSwitched)]="currentEstimate.forceBudgetValidationGp"></pop-switch>
            </div>


            <div *ngIf="settings?.activateInternalFees"
                 class="form-group">
              <label class="info-name"
                     translate="OPTIONS.LIMIT_INTERNAL_RESOURCE_BILLING_METHOD">
              </label>

              <pop-switch [disabled]="isEstimateReadonly || settings.limitInternalResourcesByBillingMethod"
                          [(isSwitched)]="currentEstimate.limitInternalResourcesByBillingMethod">
              </pop-switch>
            </div>

          </div>

          <div class="info-col">
            <div class="form-group">
              <label class="info-name"
                     for="projectManager"
                     translate="HEADER.PROJECT_LEAD">
              </label>

              <pop-select [options]="resources"
                          class="parameter-field"
                          [disabled]="isEstimateReadonly ||hasCRM"
                          keyField="id"
                          labelField="name"
                          [(selectedOption)]="currentEstimate.projectManagerId"></pop-select>

            </div>

            <div class="form-group">
              <label class="info-name"
                     for="model"
                     translate="MODAL.MODEL">
              </label>


              <pop-select [options]="projectTemplates"
                          class="parameter-field"
                          [disabled]="isEstimateReadonly || hasCRM"
                          [(selectedOption)]="currentEstimate.projectModelCode"></pop-select>

            </div>

            <div *ngIf="hasCRM"
                 class="form-group">
              <label class="info-name"
                     for="client"
                     translate="HEADER.CLIENT"></label>
              <input class="parameter-field"
                     disabled="{{ hasCRM }}"
                     type="text"
                     [(ngModel)]="currentEstimate.clientName"
                     [disabled]="!isStatusTypeNew || isGroupApproved"
                     name="client" />
            </div>

            <!--modif customer-->
            <div *ngIf="!hasCRM"
                 class="form-group">
              <label class="info-name"
                     for="client"
                     translate="HEADER.CLIENT">
              </label>


              <pop-select [options]="customers"
                          class="parameter-field"
                          [disabled]="isEstimateReadonly ||hasCRM"
                          keyField="customerName"
                          labelField="customerName"
                          [(selectedOption)]="currentEstimate.clientName"></pop-select>

            </div>

            <div class="form-group">
              <label class="info-name"
                     for="contact"
                     translate="HEADER.CLIENT_CONTACT"></label>
              <input class="parameter-field"
                     type="text"
                     [(ngModel)]="currentEstimate.clientContactName"
                     [disabled]="isEstimateReadonly || hasCRM"
                     name="contact" />
            </div>

            <div class="form-group">
              <label class="info-name"
                     for="startDate"
                     translate="MODAL.START_DATE">
              </label>

              <div class="parameter-field pop-inputs-full-width">

                <pop-date-picker-input [(date)]="currentEstimate.dateStart"
                                       [maxDate]="currentEstimate.dateEnd"
                                       [isDisabled]="isEstimateReadonly"></pop-date-picker-input>
              </div>
            </div>

            <div class="form-group">
              <label class="info-name"
                     for="endDate"
                     translate="MODAL.END_DATE"></label>

              <div class="parameter-field pop-inputs-full-width">
                <pop-date-picker-input [(date)]="currentEstimate.dateEnd"
                                       [minDate]="currentEstimate.dateStart"
                                       [isDisabled]="isEstimateReadonly"></pop-date-picker-input>

              </div>
            </div>


          </div>
        </div>
      </ng-container>

      <h2>
        <pop-chevron [(isExpanded)]="showSections.budgetType">
          <span translate="HEADER.BUDGET_TYPE"></span>
        </pop-chevron>
      </h2>
      <ng-container *ngIf="showSections.budgetType">
        <pop-estimate-budget-types [(estimateBudgetTypes)]="estimateBudgetTypes"
                                   (estimateBudgetTypesChange)="onBudgetTypeChange()"
                                   [disabled]="isEstimateReadonly"
                                   [requireConsent]="true"
                                   [fixRem]="true"
                                   [settings]="settings">
        </pop-estimate-budget-types>
      </ng-container>

      <h2>
        <pop-chevron [(isExpanded)]="showSections.currency">
          <span translate="HEADER.CURRENCY"></span>
        </pop-chevron>
      </h2>

      <ng-container *ngIf="showSections.currency">
        <div class="info-content">
          <div class="info-col">
            <div class="form-group">
              <label class="info-name"
                     for="model"
                     translate="PROPERTY_MODAL.COMPANY_CODE">
              </label>

              <select class="parameter-field"
                      #companyCode
                      disabled
                      name="companyCode"
                      [(ngModel)]="currentEstimate.companyCode"
                      [disabled]="hasCRM || isEstimateReadonly"
                      type="text">
                <option *ngFor="let company of companies"
                        [label]="company.code"
                        [value]="company.code"></option>
              </select>
            </div>
            <div class="form-group">
              <label class="info-name"
                     for="model"
                     translate="PROPERTY_MODAL.CURRENCY_CODE">
              </label>

              <select class="parameter-field"
                      #currencyCode
                      disabled
                      name="currencyCode"
                      (change)="modifyCurrency(currencyCode.value)"
                      [(ngModel)]="currentEstimate.currencyCode"
                      [disabled]="hasCRM || isEstimateReadonly"
                      type="text">
                <option *ngFor="let currency of (currencies$ | async)"
                        [label]="currency.currencyCode"
                        [value]="currency.currencyCode"></option>
              </select>
            </div>
          </div>
          <div class="info-col">
            <div class="form-group"
                 *ngIf="!isFunctionalCurrency">
              <label class="info-name"
                     for="model"
                     translate="PROPERTY_MODAL.CURRENCY_RATE">
              </label>
              <input class="parameter-field"
                     disabled
                     id="currencyRate"
                     name="currencyRate"
                     [(ngModel)]="currentEstimate.currencyRate"
                     [disabled]="true"
                     type="number" />
            </div>
            <div class="form-group"
                 *ngIf="!isFunctionalCurrency">
              <label class="info-name "
                     for="expenseType"
                     translate="PROPERTY_MODAL.OPERATION"></label>


              <pop-radio-button-group [options]="currencyOperationValues"
                                      (selectedOptionChange)="setCurrencyOperation($event)"
                                      [disabled]="true"
                                      [selectedOption]="currentEstimate.currencyRateOperation">
              </pop-radio-button-group>

            </div>
            <div class="currency-btns"
                 [matTooltipDisabled]="canUpdateCurrencyRate"
                 [matTooltip]="'TOOLTIP.CURRENCY_UP_TO_DATE' | translate"
                 *ngIf="!isFunctionalCurrency && !this.isEstimateReadonly">
              <button class="update-currency-button"
                      (click)="updateCurrencyRate()"
                      [disabled]="!canUpdateCurrencyRate">
                <i class="btn-icon fas fa-dollar-sign"></i>
                <div class="btn-text"
                     translate="BUTTON.UPDATE_CURRENCY_RATE"></div>
              </button>
            </div>

          </div>
        </div>
      </ng-container>

      <h2>
        <pop-chevron [(isExpanded)]="showSections.billingMethods">
          <span translate="MODAL.METHOD"></span>
        </pop-chevron>
      </h2>

      <ng-container *ngIf="showSections.billingMethods">
        <div class="info-content">
          <div class="info-col">
            <div class="form-group">
              <label class="info-name"
                     for="useLaborBillingMethod"
                     translate="PROPERTY_MODAL.USE_LABOR_BILLING_METHOD">
              </label>


              <pop-switch [disabled]="isEstimateReadonly ||forceLaborBillingMethod"
                          [(isSwitched)]="currentEstimate.useLaborBillingMethod"></pop-switch>

            </div>
          </div>
        </div>

        <div class="info-content">
          <div class="info-col">
            <div class="form-group">
              <label class="info-name"
                     for="laborBillingMethodCode"
                     translate="PROPERTY_MODAL.HONORARY">
              </label>
              <select [ngModel]="currentEstimate.laborBillingMethodCode"
                      (ngModelChange)="confirmMethod($event)"
                      [disabled]="!isStatusTypeNew"
                      class="parameter-field"
                      name="laborBillingMethodCode"
                      id="laborBillingMethodCode">
                <option [disabled]="!isStatusTypeNew || isGroupApproved"></option>
                <option [disabled]="!isStatusTypeNew || isGroupApproved"
                        *ngFor="let laborBillingMethodCode of (laborBillingMethodCodes$ | async)"
                        [ngValue]="laborBillingMethodCode.trim()"
                        [label]="laborBillingMethodCode"></option>
              </select>
            </div>

            <div class="form-group">
              <label class="info-name"
                     for="expenseBillingMethodCode"
                     translate="PROPERTY_MODAL.EXPENSES"></label>
              <select [(ngModel)]="currentEstimate.expenseBillingMethodCode"
                      [disabled]="!isStatusTypeNew"
                      class="parameter-field"
                      name="expenseBillingMethodCode"
                      id="expenseBillingMethodCode">
                <option [disabled]="!isStatusTypeNew || isGroupApproved"></option>
                <option [disabled]="!isStatusTypeNew || isGroupApproved"
                        *ngFor="let expenseBillingMethodCode of (expenseBillingMethodCodes$ | async)"
                        [ngValue]="expenseBillingMethodCode.trim()"
                        [label]="expenseBillingMethodCode"></option>
              </select>
            </div>
          </div>

          <div *ngIf="settings?.activateInternalFees"
               class="info-col">
            <div class="form-group">
              <label class="info-name"
                     for="internalFeeBillingMethodCode"
                     translate="PROPERTY_MODAL.INTERNAL_FEES"></label>
              <select [(ngModel)]="currentEstimate.internalFeeBillingMethodCode"
                      [disabled]="!isStatusTypeNew"
                      class="parameter-field"
                      name="internalFeeBillingMethodCode"
                      id="internalFeeBillingMethodCode">
                <option [disabled]="!isStatusTypeNew || isGroupApproved"></option>
                <option [disabled]="!isStatusTypeNew || isGroupApproved"
                        *ngFor="let internalFeeBillingMethodCode of (internalFeeBillingMethodCodes$ | async)"
                        [ngValue]="internalFeeBillingMethodCode.trim()"
                        [label]="internalFeeBillingMethodCode"></option>
              </select>
            </div>
          </div>
        </div>
      </ng-container>

    </form>

    <div class="footer-buttons">
      <button [disabled]="!isStatusTypeNew || isGroupApproved"
              class="pop-button"
              (click)="openDeleteDialog()">
        <i class="far fa-trash-alt"></i>
        <span class="info-name"
              translate="BUTTON.DELETE">
        </span>
      </button>

      <button *ngIf="hasCRM"
              class="pop-button"
              [disabled]="!isStatusTypeNew || isGroupApproved"
              (click)="syncWithCrm()">
        <i class="far fa-sync-alt"></i>
        <span class="info-name"
              translate="SYNC_CRM.BUTTON"></span>
      </button>


    </div>
  </div>


  <p-confirmDialog #de
                   appendTo="body"
                   key="de"
                   styleClass="double-confirm-dialog">
    <p-footer *ngIf="de.confirmation">
      <div>
        <input #confirmDelete
               type="checkbox"
               id="confirm-delete" />
        <label for="confirm-delete"
               class="info-name"
               translate="ERROR.CONFIRM_DELETE">
        </label>
      </div>

      <div>
        <button *ngIf="de.confirmation.acceptLabel"
                class="accept-btn"
                [disabled]="!confirmDelete.checked"
                type="button"
                pButton
                (click)="de.accept()"
                [label]="de.confirmation.acceptLabel">
        </button>
        <button class="reject-btn"
                type="button"
                pButton
                (click)="de.reject()"
                [label]="de.confirmation.rejectLabel">
        </button>
      </div>
    </p-footer>
  </p-confirmDialog>


</div>
